var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJersey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Jersey"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#BACFE3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2608347"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10453",
    width: 40,
    height: 40,
    fill: "#BACFE2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2608346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2608335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M88.0913 104.822L99.5147 101.695C100.017 101.557 100.307 101.056 100.163 100.576L86.0001 53.3235C85.6214 52.0588 84.6602 51.0262 83.3881 50.5208L71.6786 45.8594C71.0221 45.5978 69.7953 42.3349 68.7086 41.5816C67.0537 40.433 62.6469 40.4861 60.601 40.5078C58.7012 40.5294 54.6835 40.671 53.0966 41.6701C51.9172 42.4116 50.1862 45.5978 49.5296 45.8594L37.8201 50.5208C36.5481 51.0262 35.5889 52.0588 35.2081 53.3235L21.0369 100.574C20.8929 101.054 21.1831 101.555 21.6853 101.693L33.1087 104.82C33.615 104.96 34.1419 104.677 34.2819 104.191L40.9013 81.1695C40.9013 81.1695 42.1898 87.0817 42.2536 89.0859C42.3524 92.1816 41.2224 100.287 40.8046 103.158C40.7264 103.703 41.1668 104.187 41.7431 104.187H79.4671C80.0414 104.187 80.4839 103.703 80.4057 103.158C79.9879 100.285 78.8579 92.1816 78.9567 89.0859C79.0205 87.0856 80.3049 81.1872 80.3049 81.1872L86.9201 104.191C87.0601 104.677 87.587 104.96 88.0934 104.82L88.0913 104.822Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M72.4045 25.1871C72.4686 24.8261 72.5306 24.4819 72.5885 24.1545C72.8904 22.4315 74.0938 17.8585 71.8421 13.4932C70.2065 10.3221 67.1545 9.9842 67.1545 9.9842C63.9474 6.26532 56.9564 7.06702 52.5439 10.1143C49.9137 11.9297 47.2236 15.5121 47.2443 19.189C47.267 23.483 48.2885 24.7485 48.5304 24.9877C47.5193 25.1619 47.1553 27.7727 48.0011 29.5461C48.7992 31.2208 49.5394 32.6857 50.503 32.8578C52.0269 37.221 54.3821 41.1686 57.8642 42.197C58.8587 42.4908 61.7515 42.4572 62.5951 42.3607C66.774 41.878 69.1892 37.3847 70.6717 32.6311C71.3892 32.1443 72.0633 31.0278 72.7788 29.7895C73.8271 27.9763 73.579 25.1053 72.4024 25.185L72.4045 25.1871Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 2608336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M56.2178 48.3604H65.5052L63.9905 53.9922H58.1609L56.2178 48.3604Z",
    fill: "#BACFE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M58.1602 56.4016H63.7755L67.2955 92.3639L60.6477 98.6501L54 92.3639L58.1602 56.4016Z",
    fill: "#BACFE2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJersey);
export default __webpack_public_path__ + "static/media/Jersey.558a683d2ee050fae72fbf0978572100.svg";
export { ForwardRef as ReactComponent };